export default __webpack_public_path__ + "81e46c100ad89377884ff8e9d3e7a824.png";